import customFetch from '../utils/fetch';
import { API_ENDPOINTS } from '../constants/api-endpoint';

const jsonHeaders = { 'Content-Type': 'application/json' };

const getMyQualifications = async () => {
  try {
    return await customFetch(API_ENDPOINTS.QUALIFICATIONS, { method: 'GET', headers: jsonHeaders });
  } catch (error) {
    console.error('資格一覧取得エラー:', error);
    throw error;
  }
};

const getUserQualifications = async (userId) => {
  try {
    return await customFetch(API_ENDPOINTS.QUALIFICATIONS_BY_USER(userId), { method: 'GET', headers: jsonHeaders });
  } catch (error) {
    console.error('資格一覧取得エラー:', error);
    throw error;
  }
};

const getAttachment = async (id) => {
  try {
    return await customFetch(API_ENDPOINTS.QUALIFICATION_ATTACHMENT(id), { method: 'GET', headers: jsonHeaders });
  } catch (error) {
    console.error('証跡取得エラー:', error);
    throw error;
  }
};

const createQualification = async (payload) => {
  try {
    return await customFetch(API_ENDPOINTS.QUALIFICATIONS, {
      method: 'POST',
      headers: jsonHeaders,
      body: JSON.stringify(payload)
    });
  } catch (error) {
    console.error('資格登録エラー:', error);
    throw error;
  }
};

const updateQualification = async (id, payload) => {
  try {
    return await customFetch(API_ENDPOINTS.QUALIFICATION(id), {
      method: 'PUT',
      headers: jsonHeaders,
      body: JSON.stringify(payload)
    });
  } catch (error) {
    console.error('資格更新エラー:', error);
    throw error;
  }
};

export const qualificationService = {
  getMyQualifications,
  getUserQualifications,
  getAttachment,
  createQualification,
  updateQualification
};
